// Mock data for Central Wisconsin Dumpster Rental Clone

export const siteConfig = {
  name: "Dump Trailer Dude",
  tagline: "Central Wisconsin's Premier Dump Trailer Service",
  phone: "1-715-555-DUMP",
  phoneFormatted: "1-715-555-3867",
  email: "info@dumptrailerdude.com",
  address: "123 Main Street, Wausau, WI 54401",
  serviceArea: "Central Wisconsin"
};

export const navLinks = [
  { name: "About Us", href: "#about" },
  { name: "Services", href: "#services" },
  { name: "How It Works", href: "#how-it-works" },
  { name: "FAQ", href: "#faq" },
  { name: "Contact Us", href: "#contact" }
];

export const howItWorksSteps = [
  {
    step: 1,
    title: "Schedule Your Dump Trailer",
    description: "Using the 'Book Now' button, you can quickly find a location and schedule your dump trailer delivery. We've streamlined the process on our website to make it quick and easy.",
    icon: "calendar"
  },
  {
    step: 2,
    title: "We Deliver Your Trailer",
    description: "After ordering your dump trailer, all you are left to do is wait for delivery. Our experienced team will place the trailer exactly where you need it.",
    icon: "location"
  },
  {
    step: 3,
    title: "You Fill It Up",
    description: "With our dump trailer, home or commercial projects become more streamlined and efficient. Use your trailer for all sorts of jobs, such as home decluttering, office clean-outs, yard work, construction debris, and much more!",
    icon: "box"
  },
  {
    step: 4,
    title: "We Haul It Away",
    description: "Our main goal is to ensure you don't have to go to the trouble of doing everything yourself. That's why our team is always there to take the hassle out of your project with prompt dump trailer pickup.",
    icon: "truck"
  }
];

export const benefits = [
  {
    title: "Large Capacity Trailers",
    description: "Our dump trailers have more than enough space for your project. With 14 cubic yards of space, they're the goliath of dump trailer rentals, perfect for any residential or commercial cleanup.",
    icon: "maximize"
  },
  {
    title: "Effortless Loading",
    description: "Ease of use is in our DNA. Our dump trailers feature convenient 'swing-open' back doors designed close to the ground to eliminate the need for heavy lifting.",
    icon: "door-open"
  },
  {
    title: "Damage-Free Guarantee",
    description: "Say goodbye to worries about heavy drop-off trucks or weighty roll-offs damaging your driveway or nearby roads. Our wheeled dump trailers are gentle on all surfaces.",
    icon: "shield-check"
  },
  {
    title: "Precision Placement",
    description: "Our dump trailers aren't just adequately sized; they're also nimble. Thanks to their wheeled design, we can place them in areas traditional roll-offs simply can't reach.",
    icon: "target"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Mike Johnson",
    quote: "Their dump trailer service is fantastic. There are not a lot of options in town that offer to drop off a trailer and then pick it up within 24 hours. Perfect for our weekend cleanup project!",
    location: "Wausau, WI"
  },
  {
    id: 2,
    name: "Sarah Miller",
    quote: "We used Dump Trailer Dude for our home renovation project and couldn't be happier. The dump trailer was easy to load and they picked it up right on time. Highly recommend!",
    location: "Stevens Point, WI"
  },
  {
    id: 3,
    name: "Tom Anderson",
    quote: "As a contractor, I've used many waste services, but Dump Trailer Dude is by far the most convenient. Their dump trailers don't damage driveways - my clients love that.",
    location: "Marshfield, WI"
  }
];

export const faqItems = [
  {
    question: "How do I book a dump trailer?",
    answer: "From the 'Book Now' button on our website, check our availability, then give us a call. We take it from there and handle all the scheduling details for your dump trailer rental."
  },
  {
    question: "When do you deliver?",
    answer: "By default, we deliver dump trailers between 7:00 – 11:30 in the morning. However, if a specific delivery time is needed, please request it in the trailer placement notes when booking."
  },
  {
    question: "What if it rains on my delivery date?",
    answer: "Like the mail, we always deliver, whether rain or shine. But if it's not convenient for your schedule and we are able, we will honor a rescheduling request."
  },
  {
    question: "Do you load the dump trailer for me?",
    answer: "Our service differs from providers who also offer labor. With Dump Trailer Dude, the loading is up to you. This often appeals to our customers, as it eliminates the rush and pressure of having paid labor waiting on site. You can take as much time as you need!"
  },
  {
    question: "What do I do when I am done loading?",
    answer: "Absolutely nothing. We'll come to pick up the dump trailer at the end of your booking, and if you're done early, give us a call. Depending on our schedule, we'll drive out and pick it up right away."
  },
  {
    question: "Can I put anything in the trailer?",
    answer: "Be sure and check our list of 'Prohibited Items' before loading. For example, we do not accept hazardous materials, tires, batteries, or organic remains in our dump trailers."
  },
  {
    question: "Do you recycle?",
    answer: "Dump Trailer Dude is a 'green' company, and we'll always try our best to recycle whatever we can! We definitely recycle metals, cardboard, yard debris and more."
  }
];

export const galleryImages = [
  "https://images.pexels.com/photos/18805260/pexels-photo-18805260.jpeg?w=400&h=300&fit=crop",
  "https://images.pexels.com/photos/10213239/pexels-photo-10213239.jpeg?w=400&h=300&fit=crop",
  "https://images.pexels.com/photos/35685477/pexels-photo-35685477.jpeg?w=400&h=300&fit=crop",
  "https://images.unsplash.com/photo-1761479132901-45bdd8823b3e?w=400&h=300&fit=crop",
  "https://images.unsplash.com/photo-1763067036683-00e8491af467?w=400&h=300&fit=crop",
  "https://images.unsplash.com/photo-1698245900574-051997b35b2c?w=400&h=300&fit=crop"
];

export const serviceAreas = [
  "Wausau",
  "Stevens Point",
  "Marshfield",
  "Wisconsin Rapids",
  "Plover",
  "Mosinee",
  "Merrill",
  "Antigo"
];
